export const GLOBAL_STATE = 'Logs-assessment'

export const LOGS_ASSESSMENT_AUDIT = 'LOGS_ASSESSMENT_AUDIT' as const
export const LOGS_ASSESSMENT_STUDENT_LIST = 'LOGS_ASSESSMENT_STUDENT_LIST' as const
export const LOGS_ASSESSMENT_STUDENT_SUBMISSIONS = 'LOGS_ASSESSMENT_STUDENT_SUBMISSIONS' as const
